import MojitoServices from 'mojito/services';
import { omit } from 'mojito/utils';

const { RESULT_TYPE } = MojitoServices.Search.types;

/**
 * Group flat search results for the search discovery presentation.
 *
 * @param {object[]} [items = []] - Search results.
 * @returns {{sports: object[], competitions: object[], events: object[], raceMeetings: object[], playerGroups: object}} Grouped results.
 *
 * @memberof Mojito.Applications.Sports.Search
 */
export const groupResultsByType = (items = []) => {
    const grouped = {
        sports: [],
        competitions: [],
        events: [],
        raceMeetings: [],
        playerGroups: {},
    };

    items.forEach(item => {
        if (item.playerName) {
            grouped.playerGroups[item.playerName] = grouped.playerGroups[item.playerName] || [];
            grouped.playerGroups[item.playerName].push(omit(item, 'playerName'));
            return;
        }

        switch (item.resultType) {
            case RESULT_TYPE.SPORT:
                grouped.sports.push(item);
                break;
            case RESULT_TYPE.TYPE:
                grouped.competitions.push(item);
                break;
            case RESULT_TYPE.EVENT:
                grouped.events.push(item);
                break;
            case RESULT_TYPE.RACE_MEETING:
                grouped.raceMeetings.push(item);
                break;
        }
    });

    return grouped;
};

/**
 * Check whether grouped search discovery results contain any items.
 *
 * @param {{sports: object[], competitions: object[], events: object[], raceMeetings: object[], playerGroups: object}} grouped - Grouped results.
 * @returns {boolean} True when at least one result exists.
 *
 * @memberof Mojito.Applications.Sports.Search
 */
export const hasGroupedResults = grouped =>
    grouped.sports.length > 0 ||
    grouped.competitions.length > 0 ||
    grouped.events.length > 0 ||
    grouped.raceMeetings.length > 0 ||
    Object.values(grouped.playerGroups).some(items => items.length > 0);
